const verticalSlider = (postType) => (`
    ... on ${postType}_Components_Components_VerticalSlider {
        fieldGroupName
        title
        pretitle
        slides {
            description
            cta {
                target
                title
                url
            }
            fieldGroupName
            title
            image {
                altText
                link
                title
                sizes(size: LARGE)
                sourceUrl(size: LARGE)
                srcSet(size: LARGE)
            }
        }
        settings {
            fieldGroupName
            theme
            showComponentTitle
            componentTitle
            spacing
        }
    }
`);

export default verticalSlider;
